import { create } from 'zustand';

interface StreamingTextState {
  streamingTexts: Record<string, string>;
  streamingNodes: Set<string>;
  appendChunk: (nodeId: string, chunk: string) => void;
  clearStreaming: (nodeId: string) => void;
}

export const useStreamingTextStore = create<StreamingTextState>((set, get) => ({
  streamingTexts: {},
  streamingNodes: new Set(),
  appendChunk: (nodeId: string, chunk: string) => {
    set(state => {
      const current = state.streamingTexts[nodeId] || '';
      const updatedNodes = new Set(state.streamingNodes);
      updatedNodes.add(nodeId);
      return {
        streamingTexts: {
          ...state.streamingTexts,
          [nodeId]: current + chunk,
        },
        streamingNodes: updatedNodes,
      };
    });
  },
  clearStreaming: (nodeId: string) => {
    set(state => {
      const { [nodeId]: _, ...rest } = state.streamingTexts;
      const updatedNodes = new Set(state.streamingNodes);
      updatedNodes.delete(nodeId);
      return {
        streamingTexts: rest,
        streamingNodes: updatedNodes,
      };
    });
  },
}));
